import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  Form,
  Input,
  InputNumber,
  notification,
  Popconfirm,
  Row,
  Button as AntButton,
} from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import DF from 'DisplayFramework';
//import Button from 'components/Button';
import DataGrid from 'components/DataGrid';
import SaveButton from 'components/SaveButtonAction';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { indexBy, setValueByNamePath } from 'utils/utils2';
import { useFormList } from 'hooks/useFormList';
import DeleteButton from 'components/DeleteButton';
import {
  addMgUserJobAuthorization,
  getMgUserJobAuthorizationByCriteria,
  GetMgUserJobAuthorizationByCriteriaParams,
  MgUserJobAuthorizationResponse,
  removeMgUserJobAuthorization,
  updateMgUserJobAuthorization,
} from 'services/pricing';
import { isEqual } from 'lodash';
import ParListSelect from 'components/ParListSelect';
import MGListSelect from '../Components/MGListSelect';
import OfferInput from '../Management/ParametersFiltering/OfferInput';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import ButtonOperation from 'components/ButtonOperation';
import ProcedureInput from 'components/ProcedureInput';
import TaskInput from 'components/TaskInput';
import ApplicationRule from '../RuleEngine/ApplicationRule';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import PricingInputConfig from '../PricingPack/PricingInputConfig';
import SaveButtonIcon from 'components/SaveBtn';
import ThirdPartyInput from 'components/ThirdPartyInput';
import AuthorizedUsersInput from 'components/AuthorizedUsersInput';

type Values = {
  Authorization: MgUserJobAuthorizationResponse[];
};
const MgUserJobAuthorizationList = ({
  hideFiltersAndBtn,
  isModal,
  attcode,
  offerId,
  mgid,
  priid,
  isTab,
  tpid,
  tprole,
  tpreference,
  tpname,
  username,
  hidetpid,
  hidetprole,
  hideUserid,
  hideoffer,
  hidepricing,
  userId,
  rvid,
}: any) => {
  const NEW_AUTHORIZATION_ID = -1;
  const [form] = Form.useForm();
  const fieldName = 'Authorization';

  const { add, remove } = useFormList(form, fieldName, {
    idKey: 'authid',
    addAsFirst: true,
  });
  const initialSearchParams: GetMgUserJobAuthorizationByCriteriaParams = {
    attcode: isModal || isTab ? attcode : '',
    mgid: isModal || isTab ? mgid : ('' as any),
    offerid: isModal || isTab ? offerId : ('' as any),
    prcode: '',
    priid: isModal || isTab ? priid : ('' as any),
    userjob: '',
    authtype: 'USERJOB',
    tpid: tpid ?? ('' as any),
    tprole: '',
    userid: userId ?? ('' as any),
    rvid: rvid ?? ('' as any),
  };
 
  const [searchParams, setSearchParams] =
    useState<GetMgUserJobAuthorizationByCriteriaParams>(initialSearchParams);
  const [searchs, setsearchs] = useState(false);
  const [prcodefilter, setPrcodefilter] = useState<any>('');
  const [mgidfilter, setMgidfilter] = useState<any>('');
  const [offeridfilter, setOfferidfilter] = useState<any>('');
  const { data, refetch, isFetching } = useQuery(
    ['getMgUserJobAuthorizationByCriteria', searchParams],
    () =>
      getMgUserJobAuthorizationByCriteria(searchParams).then(
        (res) => res.list || []
      ),
    { enabled: searchs || isModal || isTab }
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        [fieldName]: data.map((e) => ({
          ...e,
          tpid: {
            tpid: e?.tpid,
            tpname: e?.tpname,
            tpreference: e?.tpreference,
          },
        })),
      });
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [form, data]);

  const onSaveOrEdit = useCallback(
    (record: MgUserJobAuthorizationResponse) => {
      const auth: any[] = form.getFieldValue(fieldName);
      const index = indexBy(auth, 'authid')[record.authid];
      let priidValue;
      if (typeof auth[index].priid !== 'object') {
        priidValue = auth[index].priid;
      } else {
        priidValue = auth[index].priid?.ofrid;
      }
      let finalValue = isModal || isTab ? priid : priidValue;
      const currentValue = {
        ...auth[index],
        priid: finalValue === 0 ? null : finalValue,
      };
      const { authid } = currentValue;
      if (record.attcode === '') {
        notification.error({
          message: 'Add attribut financing please ',
        });
      } else {
        authid === NEW_AUTHORIZATION_ID
          ? addMgUserJobAuthorization({
              request: {
                ...currentValue,
                tpid: tpid ? tpid : currentValue.tpid.tpid,
                authid: null as any,
                rvid: rvid ?? null,
              },
            }).then((response) => {
              if (response.code === '200') {
                notification.success({
                  message: response.message,
                });
                refetch();
              }
            })
          : updateMgUserJobAuthorization({
              authid: currentValue.authid,
              request: {
                ...currentValue,
                tpid: tpid ? tpid : currentValue.tpid.tpid,
                rvid: rvid ?? null,
              },
            }).then((response) => {
              if (response.code === '200') {
                notification.success({
                  message: response.message,
                });
                refetch();
              }
            });
      }
    },
    [form, isModal, isTab, priid, refetch]
  );
  const getName = useCallback(
    (name: string) => (record: MgUserJobAuthorizationResponse) => {
      const functions = form.getFieldValue(fieldName);
      const index = indexBy(functions, 'authid')[record.authid];

      return [fieldName, index, name];
    },
    [form]
  );
  const columns = useMemo<DataGridColDef<MgUserJobAuthorizationResponse>[]>(
    () => [
      {
        dataIndex: 'authid',

        width: 80,
        fixed: 'left',
      },
      {
        dataIndex: 'mgname',
        filtrable: 'mgid',
        filterComponent: (
          <MGListSelect
            onChange={(e) => {
              setMgidfilter(e);
            }}
          />
        ),
        render: (value, record) => (
          <Form.Item noStyle name={getName('mgid')(record)}>
            <MGListSelect
            disabled={isTab}
              onSelect={(e) => {
                setValueByNamePath(form, getName('mgid')(record), e);
                setValueByNamePath(form, getName('prcode')(record), '');
                setValueByNamePath(form, getName('offerid')(record), '');
                setValueByNamePath(form, getName('priid')(record), null);
              }}
            />
          </Form.Item>
        ),
        width: 240,
        fixed: 'left',
      },
      {
        dataIndex: 'attlabel',
        filtrable: 'attcode',
        filterComponent: <ParListSelect parcode="PRIATTR" />,
        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('attcode')(record)}>
              <ParListSelect
                parcode="PRIATTR"
                disabled={isModal || !isTab ? true : false}
              />
            </Form.Item>
          );
        },
        width: 180,
      },
      {
        dataIndex: 'tprole',
        filtrable: 'tprole',
        filterComponent: <ThirdPartyInput onlytpid />,
        render: (value, record) => {
          return (
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => (
                <Form.Item noStyle name={getName('tprole')(record)}>
                  <ParListSelect
                    parcode="BRROLE"
                    disabled
                    forcedValue="BROKER"
                  />
                </Form.Item>
              )}
            </Form.Item>
          );
        },
        width: hidetprole ? 'hide' : 180,
      },
      {
        dataIndex: 'tpid',
        filtrable: 'tpid',
        filterComponent: <ThirdPartyInput onlytpid />,
        render: (value, record) => {
          return (
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => (
                <Form.Item noStyle name={getName('tpid')(record)}>
                  <ThirdPartyInput
                    role={getFieldValue(getName('tprole')(record))}
                    isCreate={false}
                  />
                </Form.Item>
              )}
            </Form.Item>
          );
        },
        width: hidetpid ? 'hide' : 180,
      },

      {
        dataIndex: 'userid',
        filtrable: 'userid',
        filterComponent: <AuthorizedUsersInput />,
        render: (value, record) => {
          return (
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => (
                <Form.Item noStyle name={getName('userid')(record)}>
                  <AuthorizedUsersInput />
                </Form.Item>
              )}
            </Form.Item>
          );
        },
        width: hideUserid ? 'hide' : 180,
      },
      {
        dataIndex: 'productlabel',
        filtrable: 'prcode',
        filterComponent: (
          <ProductInput
            allowClear
            onSelect={(e) => {
              setPrcodefilter(e);
              setOfferidfilter('');
            }}
            onChange={(e) => {
              setPrcodefilter(e);
              setOfferidfilter('');
            }}
          />
        ),
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('prcode')(record)}
            rules={[{ required: true }]}
          >
            <ProductInput
              allowClear
              onSelect={(e) => {
                setValueByNamePath(form, getName('prcode')(record), e);
                setValueByNamePath(form, getName('offerid')(record), '');
                setValueByNamePath(form, getName('priid')(record), null);
              }}
              onChange={(e) => {
                setValueByNamePath(form, getName('prcode')(record), e);
                setValueByNamePath(form, getName('offerid')(record), '');
                setValueByNamePath(form, getName('priid')(record), null);
              }}
            />
          </Form.Item>
        ),
        width: 180,
      },

      {
        dataIndex: 'offerlabel',
        filtrable: 'offerid',
        filterComponent: (
          <OfferInput
            allowClear
            params={{
              prcode: String(prcodefilter),
              mgid: !isModal || !isTab ? mgidfilter : mgid,
            }}
            onSelect={(e) => {
              setOfferidfilter(e);
            }}
            onChange={(e) => {
              setOfferidfilter(e);
            }}
            allData
          />
        ),
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('offerid')(record)}
            rules={[{ required: true }]}
          >
            <OfferInput
              allowClear
              params={{
                prcode: form.getFieldValue(getName('prcode')(record)),
                mgid:
                  !isModal || !isTab
                    ? form.getFieldValue(getName('mgid')(record))
                    : mgid,
              }}
              allData
              onSelect={(e) => {
                setValueByNamePath(form, getName('offerid')(record), e);
                setValueByNamePath(form, getName('priid')(record), null);
              }}
              onChange={(e) => {
                setValueByNamePath(form, getName('offerid')(record), e);
                setValueByNamePath(form, getName('priid')(record), null);
              }}
            />
          </Form.Item>
        ),
        width: hideoffer ? 'hide' : 180,
      },

      {
        dataIndex: 'prilabel',
        filtrable: 'priid',
        filterComponent: (
          <PricingInputConfig
            allowClear
            params={{
              mgid: mgidfilter,
              ctetype: 'FIN',
              offerid: offeridfilter,
            }}
          />
        ),
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('priid')(record)}
            rules={[{ required: true }]}
          >
            <PricingInputConfig
              allowClear
              params={{
                mgid: form.getFieldValue(getName('mgid')(record)),
                ctetype: 'FIN',
                offerid: form.getFieldValue(getName('offerid')(record)),
              }}
            />
          </Form.Item>
        ),
        width: hidepricing ? 'hide' : 180,
      },
      {
        dataIndex: 'authtype',
        filterComponent: (
          <ParListSelect
            parcode="AUTHTYPE"
            onSelected={(e) => {
              setSearchParams({ ...searchParams, authtype: e });
            }}
            value={searchParams.authtype}
          />
        ),
        filtrable: 'authtype',
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('authtype')(record)}
            rules={[{ required: true }]}
          >
            <ParListSelect
              parcode="AUTHTYPE"
              onSelect={(e) => {
                setValueByNamePath(form, getName('userjob')(record), '');
                setValueByNamePath(form, getName('critcode')(record), '');
              }}
            />
          </Form.Item>
        ),
        width: 180,
      },
      {
        dataIndex: 'userjoblabel',
        filtrable: 'userjob',
        filterComponent: <ParListSelect parcode="USERJOB" />,
        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('userjob')(record)}>
              <ParListSelect
                parcode="USERJOB"
                disabled={
                  form.getFieldValue(getName('authtype')(record)) === 'CRITERIA'
                }
              />
            </Form.Item>
          );
        },
        width: 180,
      },

      {
        dataIndex: 'critcode',
        render: (_value, _record, index) => (
          <Form.Item name={getName('critcode')(_record)} noStyle>
            <ParListSelect
              parcode="PRCRITERIA"
              onChange={(e) => {
                setValueByNamePath(form, getName('critoperand')(_record), '');
                setValueByNamePath(
                  form,
                  getName('critvalue')(_record),
                  e === 'RULE' ? 'RULE' : ''
                );
              }}
              disabled={
                form.getFieldValue(getName('authtype')(_record)) === 'USERJOB'
              }
            />
          </Form.Item>
        ),
        width: 180,
      },
      {
        dataIndex: 'critoperand',
        render: (_value, _record, index) => (
          <Form.Item name={getName('critoperand')(_record)} noStyle>
            <ParListSelect
              parcode="CROPERAND"
              disabled={
                _record.critcode === 'RULE' ||
                form.getFieldValue(getName('authtype')(_record)) === 'USERJOB'
              }
            />
          </Form.Item>
        ),
        width: 180,
      },
      {
        dataIndex: 'critvalue',
        render: (_value, _record, index) => (
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => (
              <Form.Item name={getName('critvalue')(_record)} noStyle>
                {getFieldValue([fieldName, index, 'critoperand']) ===
                'VALUE' ? (
                  <ParListSelect
                    parcode={getFieldValue([fieldName, index, 'critcode'])}
                    disabled={
                      _record.critcode === 'RULE' ||
                      form.getFieldValue(getName('authtype')(_record)) ===
                        'USERJOB'
                    }
                  />
                ) : getFieldValue([fieldName, index, 'critoperand']) ===
                  'LIST' ? null : (
                  <Input
                    disabled={
                      _record.critcode === 'RULE' ||
                      form.getFieldValue(getName('authtype')(_record)) ===
                        'USERJOB'
                    }
                  />
                )}
              </Form.Item>
            )}
          </Form.Item>
        ),
        width: 160,
      },
      {
        dataIndex: 'critvaluemax',
        render: (_value, _record, index) => (
          <Form.Item noStyle shouldUpdate>
            <Form.Item name={getName('critvaluemax')(_record)} noStyle>
              <InputNumber
                disabled={_record.critoperand !== 'BETWEEN'}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Form.Item>
        ),
        width: 160,
      },
      {
        dataIndex: 'listvalue',
        render: (_value, _record, index) => (
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => (
              <Form.Item name={getName('listvalue')(_record)} noStyle>
                <Input
                  disabled={
                    getFieldValue([fieldName, index, 'critoperand']) !== 'LIST'
                  }
                />
              </Form.Item>
            )}
          </Form.Item>
        ),
        width: 160,
      },
      {
        dataIndex: 'valueoperand',
        render: (_value, _record, index) => (
          <Form.Item name={getName('valueoperand')(_record)} noStyle>
            <ParListSelect parcode="VALOPERAND" />
          </Form.Item>
        ),
        width: 180,
      },
      {
        dataIndex: 'valuemin',
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('valuemin')(record)}
            rules={[{ required: true }]}
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        ),
        width: 100,
      },

      {
        dataIndex: 'valuemax',
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('valuemax')(record)}
            rules={[{ required: true }]}
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        ),
        width: 100,
      },
      {
        dataIndex: 'valuedefault',
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('valuedefault')(record)}
            rules={[{ required: true }]}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        ),
        width: 100,
      },

      {
        dataIndex: 'rangemin',
        width: 100,
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('rangemin')(record)}
            rules={[{ required: true }]}
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'rangemax',
        render: (value, record) => (
          <Form.Item
            noStyle
            name={getName('rangemax')(record)}
            rules={[{ required: true }]}
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        ),
        width: 100,
      },
      {
        dataIndex: 'proccode',
        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('proccode')(record)}>
              <ProcedureInput
                entity="PROPOSAL"
                onSelect={(e) => {
                  setValueByNamePath(form, getName('taskid')(record), '');
                }}
              />
            </Form.Item>
          );
        },
        width: 180,
      },
      {
        dataIndex: 'taskid',
        render: (value, record) => {
          return (
            <Form.Item noStyle name={getName('taskid')(record)}>
              <TaskInput
                proccode={form.getFieldValue(getName('proccode')(record))}
              />
            </Form.Item>
          );
        },
        width: 180,
      },
      {
        dataIndex: 'applicationrule',
        render: (_value, _record, index) => (
          <ApplicationRule
            width={350}
            module="PRICING"
            noStyle
            form={form}
            name={[
              fieldName,
              indexBy(form.getFieldValue(fieldName), 'authid')[_record.authid],
              'applicationrule',
            ]}
          />
        ),
        width: 350,
      },
      {
        dataIndex: 'applicationruleexclude',
        render: (_value, _record, index) => (
          <ApplicationRule
            width={350}
            module="PRICING"
            noStyle
            form={form}
            name={[
              fieldName,
              indexBy(form.getFieldValue(fieldName), 'authid')[_record.authid],
              'applicationruleexclude',
            ]}
          />
        ),
        width: 350,
      },

      {
        key: 'actions',
        render: (record) =>
          record.authid === NEW_AUTHORIZATION_ID ? (
            <>
              <SaveButton
                onClick={(ev) => {
                  onSaveOrEdit(record);
                }}
                comcode="save"
                htmlType="button"
              />
              <AntButton
                danger
                icon={
                  <CloseOutlined height="14px" width="14px" color="white" />
                }
                onClick={() => remove(record.authid)}
              />
            </>
          ) : (
            <>
              <SaveButtonIcon
                onClick={() => {
                  onSaveOrEdit(record);
                }}
                size="small"
                htmlType="button"
                onlyIcon
              />
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => {
                  removeMgUserJobAuthorization({
                    authid: record.authid,
                  }).then((res) => {
                    notification.success({ message: res.message });
                    refetch();
                  });
                }}
              >
                <DeleteButton onlyIcon />
              </Popconfirm>
            </>
          ),
        width: 200,
        fixed: 'right',
      },
    ],

    [
      prcodefilter,
      mgidfilter,
      offeridfilter,
      getName,
      isModal,
      form,
      mgid,
      NEW_AUTHORIZATION_ID,
      onSaveOrEdit,
      remove,
      refetch,
    ]
  );
  const row: MgUserJobAuthorizationResponse = {
    authid: NEW_AUTHORIZATION_ID,
    attcode: attcode ?? '',
    valueoperand: 'REPLACE',
    attlabel: '',
    tpid: tpid ?? ('' as any),
    tprole: tprole ?? 'BROKER',
    userid: userId ?? ('' as any),
    mgid: mgid ?? null,
    mgname: '',
    offerid: offerId === 0 ? null : offerId,
    offerlabel: '',
    prcode: '',
    priid: priid === 0 ? null : priid,
    prilabel: '',
    proccode: '',
    proclabel: '',
    productlabel: '',
    rangemax: '' as any,
    rangemin: '' as any,
    taskid: '' as any,
    tasklabel: '',
    userjob: '',
    userjoblabel: '',
    valuemax: '' as any,
    valuemin: '' as any,
    applicationrule: '',
    applicationruleexclude: '',
    authtype: searchParams.authtype,
    critcode: '',
    critoperand: '',
    critvalue: '',
    critvaluemax: '',
    listvalue: '',
    valuedefault: '' as any,
    tpreference: tpreference ?? '',
    tpname: tpname ?? '',
    username: '',
  };
  const addRow = () => {
    add(row);
  };

  return (
    <DF.Provider pagcode="authorization">
      <Form form={form} initialValues={row}>
        <Form.Item
          noStyle
          shouldUpdate={(prevValue: Values, nextValue: Values) => {
            return !isEqual(prevValue, nextValue);
          }}
        >
          {({ getFieldValue }) => {
            const authorization: MgUserJobAuthorizationResponse[] =
              getFieldValue(fieldName);
            const isNewItemInTable =
              authorization?.find(
                ({ authid }) => authid === NEW_AUTHORIZATION_ID
              ) !== undefined;
            return (
              <DataGrid
                scroll={{ x: 2000 }}
                rowKey="authid"
                dataSource={authorization}
                title={
                  <div>
                    <Row>
                      <GetLabel label="Auth" />
                    </Row>
                    <Row>
                      <FormInput col md={6} comcode="authtype">
                        <ParListSelect
                          parcode="AUTHTYPE"
                          onSelected={(e) => {
                            setSearchParams({ ...searchParams, authtype: e });
                          }}
                          value={searchParams.authtype}
                        />
                      </FormInput>
                    </Row>
                  </div>
                }
                columns={
                  !isModal || !isTab
                    ? columns
                    : searchParams.authtype === ''
                    ? columns.filter(
                        (ea) =>
                          ea.dataIndex !== 'mgname' &&
                          ea.dataIndex !== 'productlabel' &&
                          ea.dataIndex !== 'offerlabel' &&
                          ea.dataIndex !== 'prilabel' &&
                          ea.dataIndex !== 'authtype'
                      )
                    : searchParams.authtype === 'USERJOB'
                    ? columns.filter(
                        (ea) =>
                          ea.dataIndex !== 'mgname' &&
                          ea.dataIndex !== 'productlabel' &&
                          ea.dataIndex !== 'offerlabel' &&
                          ea.dataIndex !== 'prilabel' &&
                          // ea.dataIndex !== 'proccode' &&
                          // ea.dataIndex !== 'taskid' &&
                          ea.dataIndex !== 'critcode' &&
                          ea.dataIndex !== 'critoperand' &&
                          ea.dataIndex !== 'critvalue' &&
                          ea.dataIndex !== 'critvaluemax' &&
                          ea.dataIndex !== 'listvalue' &&
                          ea.dataIndex !== 'authtype'
                      )
                    : columns.filter(
                        (ea) =>
                          ea.dataIndex !== 'mgname' &&
                          ea.dataIndex !== 'productlabel' &&
                          ea.dataIndex !== 'offerlabel' &&
                          ea.dataIndex !== 'prilabel' &&
                          ea.dataIndex !== 'userjoblabel' &&
                          ea.dataIndex !== 'authtype'
                      )
                }
                onSearch={(values) => {
                  setSearchParams(values);
                  setsearchs(true);
                }}
                initialSearchValues={initialSearchParams}
                isLoading={isFetching}
                hideFilters={hideFiltersAndBtn}
                extraActions={
                  // !isModal ? (
                  //   <Button
                  //     type="primary"
                  //     icon={<PlusOutlined />}
                  //     onClick={addRow}
                  //     disabled={isNewItemInTable}
                  //     comcode="add"
                  //   />
                  // ) : (
                    <ButtonOperation
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={addRow}
                      disabled={isNewItemInTable}
                      comcode="add"
                    />
                  // )
                }
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default MgUserJobAuthorizationList;
